import { render, staticRenderFns } from "./VaimoQuantitySelector.vue?vue&type=template&id=49460b32&scoped=true&"
import script from "./VaimoQuantitySelector.vue?vue&type=script&lang=ts&"
export * from "./VaimoQuantitySelector.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoQuantitySelector.vue?vue&type=style&index=0&id=49460b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49460b32",
  null
  
)

export default component.exports